<template>
  <div>
    <div class="nav-box">
        <div class="nav-dropDown" v-if="vm.children&&vm.children.length>0">
            <p class="nav-main-item" :class="{ isRotate: isShow}" @click="handelNemu(vm.type)">{{vm.name}}</p>
            <div class="nav-sub-box" :class="{ isNone: !isShow }" :style="{ height: `${vm.children.length * 1.173 }rem`}" v-if="vm.type!==1" >
                <p class="nav-sub-item" :class="{active: $route.path === item.path}" v-for="(item, index) in vm.children" :key="`nsi-${index}`" @click.prevent.stop="goPath(item.path)">{{item.name}}</p>
                <div class="line" v-if="isShow"></div>
            </div>
        </div>
        <router-link class="nav-a" v-else :to="vm.path">
          <div class="nav-main-item nav-temp" @click="handelOther">{{vm.name}}</div>
        </router-link>
    </div>
    <div v-if="vm.type===1" v-show="showBigProductPannel" >
      <navProductList      
        @productItemClicked="handleClickItem">      
      </navProductList>
      <div class="line" v-if="vm.type===1"></div>
    </div>
  </div>
</template>
<script>
import navProductList from '../../views/production/components/navProductList.vue'
export default {
  props: {
    vm: {
      type: Object
    },
    openType: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isShow: false,
      showBigProductPannel: false
    }
  },
  components: { navProductList },
  computed: {
    navName () {
      if (this.vm && this.vm.children && this.vm.children.length > 0) {
        let curChild = this.vm.children.find(ele => ele.path === this.$route.path)
        return curChild ? curChild.name : this.vm.name
      } else {
        return this.vm.name
      }
    },
    isClose () {
        return this.openType !== this.vm.type || !this.isShow
    }
  },
  methods: {
    handelNemu (type) {
        // if (type === this.openType) {
        //     this.isShow = !this.isShow
        // } else {
        //     this.isShow = true
        //     this.$emit('changeOpen', type)
        // }
        console.log(type)
        this.isShow = !this.isShow
        if (this.vm.type === 1) {
          this.showBigProductPannel = this.isShow
        }
    },
    handelOther () {
        this.$emit('changeOpen')
        this.closeHeader()
    },
    closeHeader () {
        this.$emit('close')
    },
    handleClickItem (itemInfo) {
      if (itemInfo.redirectType === 'newPage') {
        window.open(itemInfo.redirectUrl)
      } else {
        this.goPath(itemInfo.redirectUrl)
      }
    },
    goPath (path) {
      this.closeHeader()  
      this.$router.push(path)
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-box{
  position: relative;

  .nav-main-item{
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:#282828;
    line-height:24px;
    margin-bottom: 20px;
  }
  .nav-dropDown{
    cursor: pointer;
    position: relative;
    .nav-main-item{
      &::after{
        margin-left: 6px;
        display: inline-block;
        content: ' ';
        width: 15px;
        height: 15px;
        background: url('https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/common/icon-menu-arrow.png') no-repeat;
        background-size: 100% 100%;
        transform-origin: 50% 50%;
        transition: transform .5s;
        position: relative;
        top: 3px;
      }
      &.isRotate::after{
        transition: transform .5s;
        transform: rotate(180deg);
      }
    }
    .nav-sub-box{
      width: 110px;
      cursor: pointer;
      background: #fff;
      overflow: hidden;
      transition: all 0.5s;
      margin-bottom: 20px;
      .nav-sub-item{
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        line-height:24px;
        color: $base-font-color;
        margin-bottom: 20px;
        &:last-of-type{
          margin-bottom: 0px;
        }
      }
      .line{
        width:56px;
        height:2px;
        background:#e9e9e9;
        margin-top: 18px;
      }
      &.isNone{
        margin-top: 0px;
        height: 0px !important;
        margin-bottom: 0px;
      }
    }
  }
  .nav-a {
    color: inherit;
    text-decoration: none;
  }
  &:last-of-type{
    margin-bottom: 0px;
  }
  &.active{
    .nav-main-item{
      font-size:15px;
      font-family:PingFangSC-Semibold;
    }
  }
}
.line{
    width:56px;
    height:2px;
    background:#e9e9e9;
    margin-top: 18px;
    margin-bottom:22px
  }
</style>
